// 设计稿提取的 Unsplash 图片资源
// 这些作为后端无图时的默认占位图，保证视觉完整度

const W = (id: string, w = 1080) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=${w}`

export const HERO_BG = W('photo-1500228630616-d6905f33ad1a')

export const BANNER_BIG = W('photo-1618758993113-2447833402d6')
export const BANNER_SMALL = 'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080'
export const FLOW_BG = W('photo-1656646425022-3b4cff0bc8e2')
export const APP_DOWNLOAD_BG = W('photo-1627637819794-fba32f82be16')

// 企业封面图池（轮换使用）
export const ENTERPRISE_COVERS = [
  W('photo-1560436654-9cb8510a02cd'),
  W('photo-1497366216548-37526070297c'),
  W('photo-1497366811353-6870744d04b2'),
  W('photo-1604328698692-f76ea9498e76'),
  W('photo-1564069114553-7215e1ff1890'),
]

// 院校封面图池
export const SCHOOL_COVERS = [
  W('photo-1554752191-343d87d6c28f'),
  W('photo-1562774053-701939374585'),
  W('photo-1523050854058-8df90110c9f1'),
  W('photo-1541339907198-e08756dedf3f'),
]

// 求职攻略文章封面图池
export const ARTICLE_COVERS = [
  W('photo-1758270703329-71ad465663eb'),
  W('photo-1454165804606-c3d57bc86b40'),
  W('photo-1517245386807-bb43f82c33c4'),
  W('photo-1521791136064-7986c2920216'),
]

// 招聘会封面图池
export const JOBFAIR_COVERS = [
  W('photo-1540575467063-178a50c2df87'),
  W('photo-1505373877841-8d25f7d46678'),
  W('photo-1511578314322-379afb476865'),
]

// 登录/注册品牌侧背景
export const AUTH_LOGIN_BG = 'https://images.unsplash.com/photo-1701204129335-41bc5705392d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080'
export const AUTH_REGISTER_BG = 'https://images.unsplash.com/photo-1681171575028-16aa7a6f063e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080'

// 招聘会详情 Hero 背景
export const JOBFAIR_HERO_BG = 'https://images.unsplash.com/photo-1503418895522-46f9804cda40?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080'

// 根据 id/index 稳定地从图片池中选图
export function pickImage(pool: string[], seed: string | number): string {
  const n = typeof seed === 'number' ? seed : String(seed).split('').reduce((a, c) => a + c.charCodeAt(0), 0)
  return pool[n % pool.length]
}
